import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import DialogContentText from '@mui/material/DialogContentText';
import { lazy, Suspense } from 'react';
const DevToolsContents = lazy(() => import(/* webpackChunkName: "dev-tools" */ '../../devTools/devToolsContents'));
export const DevToolsMessageBoxContents = () => {
    return (_jsx(DialogContentText, { component: 'div', children: _jsx(Suspense, { fallback: _jsx("div", { children: "Loading..." }), children: _jsx(DevToolsContents, {}) }) }));
};
